import { useSharedValue } from "react-native-reanimated";

export const useVector = (x1 = 0, y1?: number) => {
  const x = useSharedValue(x1);
  const y = useSharedValue(y1 ?? x1);
  return { x, y } as const;
};
